import styled from 'styled-components';
import { Colors, Row } from 'basic-ui-lib';
import { IcImage, IcLink } from 'basic-ui-lib/icons';
import { ContentType } from 'modules/dashboard/interfaces/api';

interface ContentTabsProps {
  activeTab: ContentType;
  mediaCount: number;
  linksCount: number;
  onTabChange: (tab: ContentType) => void;
}

const ContentTabs = ({ activeTab, mediaCount, linksCount, onTabChange }: ContentTabsProps) => {
  return (
    <Row justifyContent="center" gap={8} paddingBottom={16} style={{ borderBottom: `1px solid ${Colors.neutral.border[1]}` }}>
      <TabButton 
        $active={activeTab === 'media'} 
        onClick={() => onTabChange('media')}
      >
        <IcImage width={20} height={20} fill={Colors.neutral.text[5]} />
        <span>Media</span>
        <TabBadge $active={activeTab === 'media'}>{mediaCount}</TabBadge>
      </TabButton>
      <TabButton 
        $active={activeTab === 'link'} 
        onClick={() => onTabChange('link')}
      >
        <IcLink width={20} height={20} fill={Colors.neutral.text[5]} />
        <span>Links</span>
        <TabBadge $active={activeTab === 'link'}>{linksCount}</TabBadge>
      </TabButton>
    </Row>
  );
};

export default ContentTabs;

const TabButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 24px;
  border-radius: 100px;
  border: 1px solid ${({ $active }) => ($active ? Colors.secondary[5] : Colors.neutral.border[1])};
  background: ${({ $active }) => ($active ? Colors.primary[2] : Colors.neutral.bg[1])};
  cursor: pointer;
  transition: all 0.2s ease;

  span {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: ${Colors.neutral.text[5]};
  }

  &:hover {
    background: ${({ $active }) => ($active ? Colors.primary[2] : Colors.neutral.bg[2])};
  }
`;

const TabBadge = styled.span<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: 12px;
  background: ${({ $active }) => ($active ? Colors.other[3] : Colors.neutral.bg[3])};
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: ${({ $active }) => ($active ? Colors.neutral.bg[1] : Colors.neutral.text[5])} !important;
`;
